import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { getCatalogRegistration } from '@/redux/modules/catalogRegistration';
import { getLiveItemStatus } from '@/redux/modules/liveItemStatus';
import isEqual from 'react-fast-compare';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

type Props = {
    catalogId: number;
    itemId: number;
};

const ItemBidToast = ({ catalogId, itemId }: Props) => {
    const [messageShown, setMessageShown] = React.useState(false);

    const { approved } = useSelector((state) => getCatalogRegistration(state, catalogId), isEqual);
    const { open: live } = useSelector((state) => getLiveItemStatus(state, itemId), isEqual);

    React.useEffect(() => {
        if (window.localStorage && window.localStorage.liveItemBiddingMessageShown) {
            setMessageShown(true);
        }
    }, []);

    React.useEffect(() => {
        if (!messageShown && approved && live) {
            window.localStorage.liveItemBiddingMessageShown = true;
            setMessageShown(true);
            toast(<FormattedMessage id="toastMessage" />);
        }
    }, [approved, live, messageShown]);

    return null;
};

export default React.memo<Props>(ItemBidToast);
